// src/redux/offlineTransaction/OfflineTransactionSlice.js
import { createSlice } from "@reduxjs/toolkit";

const offlineTransactionSlice = createSlice({
  name: "offlineTransaction",
  initialState: {
    loading: false,
    data: [],
    total: 0,
    message: "",
    error: null,
  },
  reducers: {
    fetchOfflineTransactionRequest: (state, action) => {
      state.loading = true;
    },
    fetchOfflineTransactionSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.orders;
      state.total = action.payload.total;
      state.message = action.payload.message;
    },
    fetchOfflineTransactionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

     verifyOfflineTransactionRequest: (state, action) => {
      state.loading = true;
    },
    verifyOfflineTransactionSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    },
    verifyOfflineTransactionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

     cancelOfflineTransactionRequest: (state, action) => {
      state.loading = true;
    },
    cancelOfflineTransactionSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    },
    cancelOfflineTransactionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchOfflineTransactionRequest,
  fetchOfflineTransactionSuccess,
  fetchOfflineTransactionFailure,
  verifyOfflineTransactionRequest,
  verifyOfflineTransactionSuccess,
  verifyOfflineTransactionFailure,
  cancelOfflineTransactionRequest,
  cancelOfflineTransactionSuccess,
  cancelOfflineTransactionFailure,
} = offlineTransactionSlice.actions;

export default offlineTransactionSlice.reducer;
